import React from "react";

function article_1() {
	return {
		date: "29 September 2023",
		title: "My experience: Second drone workshop",
		description:
			"Deep diving into the concepts of drone making and aviation",
		keywords: [
			"The Benefits of Cloud Computing",
			"Arya",
			"Arya V",
			"Arya Vats",
		],
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="article-content">
					<img
						src="https://i.ibb.co/Ytmzh3b/IMG-3433.jpg"
						alt="random"
						className="randImage"
					/>
					<br />
					<br />
					I love to explore drones and aviation whenever I find time
					from work. I do a lot of reading and teaching. This was my
					second workshop that took place at RKGIT, Ghaziabad, as I
					was invited as a speaker to motivate the young minds into
					expanding their knowledge domain and build extra projects as
					well.
					<br />
					Building drones can be challenging and a little overwhelming
					at first, but with the right mindset and interest, anyone
					can build their own drone. I have mentored several students
					to help them build drones. Ranging from the software to the
					hardware, I have taught many students the know-how that goes
					behind the drones or for that matter any basic aerial
					vehicle. This workshop started with explanation of why
					drones are so important, what is their scope and how will
					the government invest an enormous amount of money into the
					drone industry in the coming years.
					<br />
					<br />
					I started off with this and progressed towards the basic
					concepts and the components that are required to build your
					very first drone.
					<br />
					<br />
					<br />
					<img
						src="https://i.ibb.co/LkXpkxb/IMG-3400.jpg"
						alt="random"
						className="randImage"
					/>
					<br />
					<br />
					Slowly and steadily we proceeded towards getting to know the
					resources that are available on the internet and how to find
					the right ones. I always recommend every student to read
					documentation thoroughly because documentation to drones is
					what internet is to a laptop. You have a machine but without
					documentation, you cannot perform anything with it.
					<br />
					<br />
					There was a lot of QnA afterwards and the students were
					amazing, and had a curiosity to learn. That's all what was
					needed! 😃
					<br />
					<br />
					<br />
					<br />
					<img
						src="https://i.ibb.co/9YwDCsg/IMG-3427.jpg"
						alt="random"
						className="randImage"
					/>
					<br />
					<br />
					<br />
				</div>
			</React.Fragment>
		),
	};
}

function article_3() {
	return {
		date: "23 September 2022",
		title: "My experience: First drone workshop",
		description:
			"Deep diving into the concepts of drone making and aviation",
		keywords: [
			"The Benefits of Cloud Computing",
			"Arya",
			"Arya V",
			"Arya Vats",
		],
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="article-content">
					<img
						src="https://i.ibb.co/p36nFYw/Screenshot-2023-10-06-at-5-50-49-PM.png"
						alt="random"
						className="randImage"
					/>
					<br />
					<br />
					This was my first experience giving lecture in front of such
					a huge gathering. I have given lectures before, but most of
					them were in my college, so this was a surprise for me. This
					is where the spark behind PUSHPAK-the drone society of RKGIT
					was ignited. These were the first set of core students that
					I mentored and they are the ones who have laid the
					foundation of their society.
					<br />
					For a workshop to succeed, I believe the students do play an
					important role. It is the interactivity, the interest, the
					enthusiasm from students that helped me dive much much
					deeper into the know-how of drones.
					<br />
					<br />
					What started off as a casual interaction turned out to be
					such a game changer for both sides as the students were so
					much curious and interested towards exploring different
					domain as an expanded domain.
					<br />
					<br />
					<br />
					<img
						src="https://i.ibb.co/7Wq0Y35/Screenshot-2023-10-06-at-5-50-26-PM.png"
						alt="random"
						className="randImage"
					/>
					<br />
					<br />
					The discussion started as usual with me explaining about
					drones and aviation industry. As the discussion proceeded,
					the students became more and more curious about drones and
					the tech that goes behind them. That's all what I needed
					from them!, their interest. So it went on for hours about
					the drones and me explaining about the construction of basic
					to complex drones, and also discussing about biomimicry.
					<br />
					<br />
					All in all, it was a fruitful experience for me and I hope,
					it was for the students as well 😅.
					<br />
					<br />
					<br />
					<br />
				</div>
			</React.Fragment>
		),
	};
}

function article_2() {
	return {
		date: "29 September 2023",
		title: "Quick snake game with Python- PART I",
		description:
			"Understanding python OOPS and classes by building a snake game",
		keywords: ["Python", "Arya", "Arya V", "Arya Vats"],
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="article-content">
					<img
						src="https://i.ibb.co/kBgTpxQ/snake.gif"
						alt="random"
						className="randImage"
					/>
					<br />
					<br />
					I strongly believe in the idea that building a snake game
					can really help in mastering the basics of any language.
					Why?. Simple answer- because it tests you for each and every
					different or new concept that beginners might find difficult
					to go through.
					<br />
					<br />
					Why do I love snake game? simply because I like to build it
					with every new programming langugage or framework that I
					learn. It tests some basic BUT important concepts of OOPS
					that can really zip you through large codes easily.
					<br />
					To build the snake game today, we will be using the turtle
					library that is available in python. To read more about what
					is turtle and how does it work, you can read it on the
					official turtle documentation. That's really helpful. So,
					proceeding with the steps, we will divide our game into 5
					PARTS:
					<strong>
						<li>Part 1: Making of canvas and turtle</li>
						<li>Part 2: Making a snake class</li>
						<li>
							Part 3: Inheriting the turtle class attributes into
							our snake class
						</li>
						<li>
							Part 4: Making our food class and Inheriting the
							turtle class attributes into it
						</li>
						<li>Part 5: Making our scoreboard class</li>
					</strong>
					<br />
					<br />
					<striong>
						<i>PART-1</i>
					</striong>
					For part 1, we need to define a class named snake.py. After
					defining a class, let's import turtle module using{" "}
					<u>"from turtle import Turtle"</u>
					Now, we could have simply done{" "}
					<b>import turtle OR from turtle import *</b>
					but the problem with the second and third approach is that
					they import all the unnecessary functions and classes apart
					from Turtle that we do not need. This just increases the
					memory consumption of our app which we do not require 😀.
					After we have imported our turtle package and imported the
					Turtle class, we are now ready to make our snake class. Now
					if we think what all attributes a snake might have, then the
					first thing comes into our mind is it's head and a way to
					actually create the snake.
					<br />
					<br />
					<img
						src="https://i.ibb.co/Zd6QcFf/Screenshot-2023-10-10-at-7-16-13-PM.png"
						alt="random"
						className="randImage"
					/>
					<br />
					<br />
					Once we have defined all the important attributes, you might
					be wondering what is "STARTING_POSITIONS, MOVE_DISTANCE etc
					?". Well these are the values that define the basic behavior
					of snake. When we define a turtle we do have to specify how
					many paces will it walk and etc. We will talk about the
					usage of STARTING_POSITIONS , but as of now just just let it
					stay where it is.
					<br />
					<br />
					<br />
					<img
						src="https://i.ibb.co/S5NpFL7/Screenshot-2023-10-10-at-7-36-09-PM.png"
						alt="random"
						className="randImage"
					/>
					<br />
					<br />
					Now, let's think of one thing, if we create one turtle and
					make it move, then what about when our snake eats the food?
					How will we make its body? For that, notice we have added an
					attribute "self.segments" that is a list and notice how I am
					only concerned about the segments[0] to be the head. That is
					the trick! You make one as the head and let rest follow
					behind it. We will see how.
					<br />
					<br />
					<img
						src="https://i.ibb.co/Kb3Xybd/Screenshot-2023-10-10-at-7-50-25-PM.png"
						alt="random"
						className="randImage"
					/>
					<br />
					<br />
					Now , here is the interesting portion. We define a new
					function named add_segment that basically just makes an
					instance of a turtle with parameters like penup(), color and
					goto that essentially just makes sure that the turtle is not
					drawing on the screen, its color is white and its on a
					predefined position. After we have made our turtle, it is
					now time to append it to the segments list. Now you might
					have guessed it! Segments is a list of all the turtle
					instances that are added whenever our snake eats its food.
					So, a new function increase_size basically just makes a new
					snake based on the last turtle's position. Notice I have
					used negative indexing. We use that to take hold of the last
					element in the list. We have defined our snake. We now need
					to define the directions such that it can move left, right,
					up and down. For that we define functions.
					<br />
					<br />
					<img
						src="https://i.ibb.co/h7pCgd4/Screenshot-2023-10-10-at-8-00-25-PM.png"
						alt="random"
						className="randImage"
					/>
					<br />
					<br />
					These functions do nothing but change the direction of the
					turtle by using setheading method that is available for
					every turtle object. And alsp, we have tackled some small
					corner cases here, just imagine if our snake is going down,
					we don't want it to go opposite when we press the up button
					right? That basically defies the rules of the game, and
					similar for right and left. That's what we have checked in
					these functions apart from setting the heading position.
					Notice these LEFT, RIGHT, DOWN, UP. We have already defined
					these at the start!. This is exactly what they were for!
					That's it for the part 1 😀. Follow along the part 2 blog to
					continue this exciting game!
				</div>
			</React.Fragment>
		),
	};
}

const myArticles = [article_1, article_2, article_3];

export default myArticles;
